const SINGLE_PAGE = 'SINGLE_PAGE';
const LISTING_PAGE = 'LISTING_PAGE';

module.exports = {
  SINGLE_PAGE,
  LISTING_PAGE,
};


// WEBPACK FOOTER //
// ./modules/constants.js